import {action, makeAutoObservable, observable} from "mobx";
import {TIMELINE_MIN_DURATION} from "../config/config";
import {CompositionService} from "../services/CompositionService";
import {Clip} from "../../editorCore/clips";

export interface UserClip {
    id: string;
    type: string;
    startTime: number;
    leftTrim: number;
    rightTrim: number;
    duration: number;
    trimmedDuration: number;
    hasPredecessor?: boolean;
    hasSuccessor?: boolean;
}

export interface Layer {
    id: string;
    clipIds: string[];
}

export interface Transition {

}

class CompositionStateStoreInstance {
    orderedLayerIds: string[] = []; // in reverse order
    duration: number = TIMELINE_MIN_DURATION;
    clips: Record<string, UserClip> = {};
    layers: Record<string, Layer> = {};
    transitions: Record<string, Transition> = {};

    constructor() {
        makeAutoObservable(this, {
            setDuration: action,
            updateTimelineDuration: action,
            setOrderedLayerIds: action,
            orderedLayerIds: observable,
        });
    }

    setOrderedLayerIds(orderedLayerIds: string[]) {
        this.orderedLayerIds = orderedLayerIds;
    }

    setDuration(duration: number) {
        this.duration = duration;
    }

    updateTimelineDuration() {
        const duration = Math.max(TIMELINE_MIN_DURATION, CompositionService.getFitDuration() + 10);
        this.setDuration(duration);
    }

    getFilenameByClipId(clipId: string) {
        return "clip-filename"
    }

    getThumbnailByClipId(clipId: string) {
        return "clip-thumbnail"
    }

    addLayer(layer: Layer) {
        this.layers[layer.id] = layer;
        this.orderedLayerIds.push(layer.id);
    }

    addClip(layerId: string, clip: Clip) {
        const userClip : UserClip = { id: clip.id, type: "video", startTime: clip.start.seconds, duration: clip.stop.seconds - clip.start.seconds, leftTrim: 0, rightTrim: 0, trimmedDuration: clip.stop.seconds - clip.start.seconds, hasPredecessor: false, hasSuccessor: false };
        this.clips[clip.id] = userClip;

        if (this.layers[layerId]) {
            this.layers[layerId].clipIds.push(clip.id);
        } else {
            this.layers[layerId] = { id: layerId, clipIds: [clip.id] };
            this.orderedLayerIds.push(layerId);
        }
    }
}

const CompositionStateStore = new CompositionStateStoreInstance();

export { CompositionStateStore };